import React, { useEffect, useState } from 'react';

const navStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0,
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '1.1rem 3.5rem',
  background: 'rgba(5,8,15,0.65)',
  backdropFilter: 'blur(14px)',
  borderBottom: '1px solid rgba(26,108,245,0.18)',
  transition: 'background 0.3s',
};

const logoStyle = {
  fontFamily: "'Syne', sans-serif",
  fontWeight: 800,
  fontSize: '1.35rem',
  background: 'linear-gradient(135deg, #4d94ff, #1a6cf5, #a78bfa)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textDecoration: 'none',
  letterSpacing: '-0.02em',
};

const LINKS = [
  { label: '01. About',        href: '#about' },
  { label: '02. How I Work',   href: '#howIWork' },
  { label: '03. Case Studies', href: '#caseStudies' },
  { label: '04. Contact',      href: '#contact' },
];

function Navbar() {
  const [active, setActive] = useState('');

  // Highlight active section on scroll
  useEffect(() => {
    const onScroll = () => {
      const sections = ['about', 'howIWork', 'caseStudies', 'contact'];
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120 && rect.bottom >= 120) { setActive(id); break; }
        }
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav style={navStyle}>
      <a href="#top" style={logoStyle}>ZD.</a>

      {/* Bootstrap navbar-nav repurposed for inline links */}
      <ul className="navbar-nav flex-row gap-4 mb-0">
        {LINKS.map(({ label, href }) => {
          const id = href.replace('#', '');
          return (
            <li className="nav-item" key={href}>
              <a
                className="nav-link p-0"
                href={href}
                style={{
                  color: active === id ? 'var(--blue-light)' : 'var(--muted)',
                  fontSize: '0.82rem',
                  fontWeight: 500,
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={e => e.target.style.color = 'var(--blue-light)'}
                onMouseLeave={e => e.target.style.color = active === id ? 'var(--blue-light)' : 'var(--muted)'}
              >
                {label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default Navbar;
